// extracted by mini-css-extract-plugin
export default {"root":"u61UBWaPtlc4QbdzNK_W","wrapper":"hgYawYwxiAlmsihW8wbS","icon":"UrZsh25nIQXpgSNeq6qO"};